import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './WinnerTicker.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function shorten(addr) {
  if (!addr) return '—';
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

function formatUSDC(raw) {
  if (raw == null) return '$0';
  return `$${(Number(raw) / 1_000_000).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

function timeAgo(ts) {
  if (!ts) return '';
  const secs = Math.max(1, Math.floor(Date.now() / 1000 - Number(ts)));
  if (secs < 60) return `${secs}s ago`;
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

/**
 * Scrolling ticker of the most recent tournament winners.
 * Renders nothing if no winners yet (pre-launch).
 */
export default function WinnerTicker() {
  const [winners, setWinners] = useState([]);

  useEffect(() => {
    let cancelled = false;
    function load() {
      fetch(`${API}/tournament/recent-winners?limit=10`)
        .then(r => r.json())
        .then(d => { if (!cancelled) setWinners(d.winners || []); })
        .catch(() => {});
    }
    load();
    const id = setInterval(load, 30_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (winners.length === 0) return null;

  // Duplicate the list so the CSS marquee loops seamlessly
  const items = [...winners, ...winners];

  return (
    <div className="wticker">
      <div className="wticker__label">🏆 Live Winners</div>
      <div className="wticker__track">
        <div className="wticker__scroll">
          {items.map((w, i) => (
            <Link
              to="/results"
              key={`${w.tournamentId}-${i}`}
              className="wticker__item"
            >
              <span className="wticker__trophy">🏆</span>
              <span className="wticker__handle">{w.handle || shorten(w.walletAddress)}</span>
              <span className="wticker__game"> · {w.game === 'fortnite' ? 'Fortnite' : 'Apex'}</span>
              <span className="wticker__amount">{formatUSDC(w.winnerPayout)}</span>
              <span className="wticker__ago">{timeAgo(w.resolvedAt)}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
